import type { ReactNode } from "react";
import { tw } from "../../styling";

export type PillStatus = "success" | "pending" | "error" | "info";

type Props = {
	text: string | ReactNode;
	status: PillStatus;
	size?: "sm" | "md";
};

const bgColors: Record<PillStatus, string> = {
	error: tw`bg-background-critical`,
	info: tw`bg-background-info`,
	pending: tw`bg-background-alert`,
	success: tw`bg-background-success`,
};

const textColors: Record<PillStatus, string> = {
	error: tw`text-text-error`,
	info: tw`text-foreground-info`,
	pending: tw`text-text-alert`,
	success: tw`text-foreground-success`,
};

export const Pill = ({ text, status, size = "md" }: Props) => {
	return (
		<span role="status">
			<span
				className={tw(
					"tablet:text-sm/6 m-auto inline-block rounded-md px-2",
					size === "sm" ? "text-sm" : "text-base",
					bgColors[status],
					textColors[status],
				)}
			>
				{text}
			</span>
		</span>
	);
};
